import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[policy-type]'
})
export class PolicyTypeDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}